import { LoadingSpinner } from '@/components/common/LoadingSpinner';

export function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-zoooffwhite">
      <LoadingSpinner className="w-8 h-8" />
    </div>
  );
}
